export default [
  { id: 1, label: 'Amusnet' },
  { id: 2, label: 'Amatic' },
  { id: 3, label: 'Skywind' },
  { id: 4, label: 'CT Interactive' },
  { id: 5, label: 'Novomatic' },
  { id: 6, label: 'Spribe' },
  { id: 7, label: 'Pragmatic' },
  { id: 8, label: 'Evolution' },
  { id: 9, label: 'iSoftBet' },
  { id: 10, label: 'Relax Gaming' },
  { id: 11, label: 'EGT Digital' },
  { id: 12, label: 'Nevada' },
  { id: 13, label: 'OmniPlay' },
  { id: 15, label: 'Hacksaw' },
  { id: 16, label: 'Wazdan' },
  { id: 17, label: 'Playson' },
  { id: 18, label: 'Playtech' },
  { id: 20, label: 'Section8' },
  { id: 21, label: 'Split The Pot' },
  { id: 22, label: 'Booming' },
  { id: 23, label: 'Pateplay' },
];

export const GameProviderId = {
    EGT: 1,
    AMATIC: 2,
    SKYWIND: 3,
    CT: 4,
    NOVOMATIC: 5,
    SPRIBE: 6,
    PRAGMATIC: 7,
    EVOLUTION: 8,
    ISOFTBET: 9,
    RELAX: 10,
    EGT_DIGITAL: 11,
    NEVADA: 12,
    OMNIPLAY: 13,
    HACKSAW: 15,
    WAZDAN: 16,
    PLAYSON: 17,
    PLAYTECH: 18,
    SECTION8: 20,
    SPLIT_THE_POT: 21,
    BOOMING: 22,
    PATEPLAY: 23,
};